<template>
  <a-button @click="openModal" v-if="IsShwoBtn && typebtn !== 'text'" :type="typebtn">
    {{btnName}}
  </a-button>
  <a
      v-if="IsShwoBtn && typebtn == 'text'"
      href="javascript:void(0);"
      type="link"
      @click="openModal"
      class="theme-color"
      :style="{ color: '#2F7BFF'}"
    >
      {{btnName}}
    </a>
  <a-modal
      :centered="true"
      :keyboard="false"
      :mask-closable="false"
      v-model:visible="visible"
      :title="btnName"
      ok-text="确认"
      cancel-text="取消"
      @ok="ok"
    >
      <a-form layout="vertical" :model="formModel" ref="formRef">
        <a-form-item>
          <a-textarea  :placeholder="placeholder" v-model:value="formModel.remark" showCount :rows="4" :maxlength="200" />
        </a-form-item>
      </a-form>
    </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, computed } from "vue";
import { getCurrentUserId } from "@/utils";
import { PaymentFlowService } from "../payment-flow-btn.service";
import { message } from "ant-design-vue";

export default defineComponent({
  isGlobal: true,
  name: "CancelPaymentBtn",
  props: {
    api: {
      type: String,
    },
    typebtn: {
      type: String,
      default: 'primary'
    },
    btnName: {
      type: String,
      default: '取消收款'
    },
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    contractId: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    formRef:{
      type:Object,
      default:()=>{
        return {}
      }
    },
    record: {
      type: Object,
      default: () => {},
    },
    externalBizType: {
      type: String,
      default: "",
    },
    externalIdKey: {
      type: String,
      default: "",
    },
    applyPaymentId: {
      type: String,
      default: undefined,
    },
    columnName:{
      type: String,
      default: undefined,
    },
  },
  emits: ["refresh"],
  setup(props,{emit}) {
    const visible = ref(false);
    const formModel = reactive({
      reason: '取消收款',
      remark: '',
    });

    const placeholder = computed(() => {
      return `请输入${props.btnName}原因,最多200字`;
    });

    const { run, loading } = PaymentFlowService.useInvoiceStatusChangeApi();
    const { run: runIds } = PaymentFlowService.useInvoiceStatusChangeApis();

    const options = reactive([
      {code: 1, name: '取消收款'}
    ]);

    const openModal = () => {
      visible.value = true
      formModel.reason = '取消收款'
      formModel.remark = ''
    }
    const state = reactive({
      currentUserId: getCurrentUserId(),
    });
    const IsShwoBtn = computed(() => {
      // console.log(props.record);
      
      if (props.record) {
        return (props.record.createBy === state.currentUserId  || props.record.finalReviewerFlag);
      }else {
        return false
      }
      
    });

    const ok = async () => {
      // console.log('props111', props);
      const res = props.bizType === "payment_order_external_examine" ? 
         await runIds([], null, [props.bizId], props.bizType, '', formModel.remark,props.status)
         : await run([], props.bizId, props.bizType, '', formModel.remark,props.status)
      if (props?.record?.selectBizType) { //对外付款单，如果
       await runIds(
          [],
          null,
          props.record.applyPaymentIds,
          //@ts-ignore
          props?.record?.selectBizType,
          'LEASEPAYMENT',
          "",
          props.status
        );
      }
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
        return;
      }
      if (props.externalBizType != "") {
        const res2 = await run(
          [],
          props.record[props.externalIdKey],
          props.externalBizType,
          "",
          "",
          props.status,
          props.columnName
        );
      }
      message.success(res.respDesc);
      emit("refresh", null);
      visible.value = false

    }

    return {
      loading,
      visible,
      formModel,
      options,
      openModal,
      ok,
      placeholder,
      ...toRefs(state),
      IsShwoBtn,
    };
  },
});
</script>

<style scoped></style>

function emit(arg0: string, arg1: null) {
  throw new Error("Function not implemented.");
}
